import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { DragWrapper } from "designSystem/dnd/index";
import { FlexColumn, FlexRow, IconButton } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import BaseCompositionBOMMaterialList from "./BaseCompositionBOMMaterialList";
import BaseCompositionMaterialList from "./BaseCompositionMaterialList";
import BaseCompositionPlacementSingleItemInnerRowContent from "./BaseCompositionPlacementSingleItemInnerRowContent";
import { useBaseCompositionStore } from "./BaseCompositionStore";
import { CompositionPlacement } from "./CompositionPlacement";
import { SalesRegionException } from "./SalesRegionException";

interface BaseCompositionPlacementSingleItemProps {
	currentPlacement: CompositionPlacement;
	index?: number;
	isDragging?: boolean;
	salesRegionException: SalesRegionException;
} 

const BaseCompositionPlacementSingleItem: FunctionComponent<BaseCompositionPlacementSingleItemProps> = observer(
	function BaseCompositionMaterialSingleItem(props) {
		const { currentPlacement, index = 0, isDragging = false, salesRegionException } = props;
		const {
			fromStyleBom,
		} = useBaseCompositionStore();
		const ListComponent = fromStyleBom ? BaseCompositionBOMMaterialList : BaseCompositionMaterialList;

		return (
			<FlexColumn
				alignItems="flex-start"
				bgcolor={grey[50]}
				border={1}
				borderColor={grey[300]}
				borderRadius={1}
				data-csi-automation="CompositionPlacement"
				gap={2}
				paddingRight={2}
				paddingY={3}
			>
				<FlexRow
					alignItems="center"
					data-csi-automation="CompositionPlacementAggregated"
					gap={1}
					minWidth={200}
					paddingX={2}
					width="100%"
				>
					<DragWrapper 
						canDrag
						dragItem={currentPlacement}
						dragType="CompositionPlacement"
						isFullScreen
					>
						<IconButton
							design="dragHandle"
							size="small"
							tabIndex={-1}
						>
							<DragIndicatorIcon />
						</IconButton>
					</DragWrapper>
					<BaseCompositionPlacementSingleItemInnerRowContent 
						currentPlacement={currentPlacement}
						index={index}
						isDragging={isDragging}
						salesRegionException={salesRegionException}
					/>
				</FlexRow>
				{!isDragging && (
					<ListComponent 
						addBaseCompositionMaterial={currentPlacement.addBaseCompositionMaterial}
						baseCompositionMaterials={currentPlacement.baseCompositionMaterials}
						compositionMaterialsHaveDummy={currentPlacement.compositionMaterialsHaveDummy}
						parent={currentPlacement}
					/>
				)}
			</FlexColumn>
		);
	},
);

export default BaseCompositionPlacementSingleItem;